import { createWebgl, webgl } from './core/GL.js'

import HomeScene from './components/HomeScene.js'

export default createWebgl({
    setup() {
        const { $renderer } = webgl
        $renderer.setup({ antialias: true, alpha: true })
    },

    start() {
        const { $renderer, $scenes } = webgl
        $renderer.resize()

        $scenes.main = new HomeScene()
        $scenes.main.init()
    },

    update() {
        const { $scenes } = webgl
        const scene = $scenes.main
        if (!scene) return
        scene.update()
    },

    render() {
        const { $scenes } = webgl
        const scene = $scenes.main
        if (!scene) return
        scene.render()
    }
})
